export default "__VITE_ASSET__df75a671__"